var defaultConf = require('./config-default');

var BO_URL = 'aecs2022-data.ms-dev.mobile-spot.com'; //const BO_TAIGA_URL = 'https://pgorganisation.site.calypso-event.net';

var NODE_BACKEND_DOMAIN = 'aecs-node-backend-dev.mobile-spot.com';
var NODE_WS_BAKEND_DOMAIN = '';
module.exports = require('deepmerge')(defaultConf, {
  ENV: 'dev',
  BO_URL: BO_URL,
  // no trailing '/'
  BO_PATH: '/home/legacy/aecs/aecs2022/aecs2022-data.ms-dev.mobile-spot.com',
  // no trailing '/'
  BO_SERVER_ALIAS: 'ms-dev.mobilespot.prodleni.local',
  BO_SSH_PORT: '22',
  BO_SSH_USER: 'legacy',
  // 'www'
  DEPLOY_PATH: '/home/legacy/aecs/aecs2022/aecs2022.ms-dev.mobile-spot.com',
  GOOGLE_ANALYTICS_ID: 'UA-48506479-46',
  // LOGIN: {
  //   forgottenPasswordURL: `${BO_TAIGA_URL}/mobile-se/mot-de-passe-oublie.htm`,
  // },
  projectId: '1056757301402',
  // FCM sender id
  appId: '2E560-C6132',
  // pushwoosh appid
  SEND_EXPORTED_NOTES_MAIL: {
    WS_URL: 'http://localhost:3096/api/exportNotesByMail',
    EXPEDITOR: 'no-reply@mobile-spot.com',
    KEY: 'zpgZkgiz845gjzFzi'
  },
  ADDITIONAL_DEFAULTSRC_CSP: (Array.isArray(defaultConf.ADDITIONAL_DEFAULTSRC_CSP) ? defaultConf.ADDITIONAL_DEFAULTSRC_CSP : []).concat([]),
  CHECK_NETWORK_URL: "https://".concat(BO_URL, "/online.txt"),
  SYNCHRONIZED_FAVORITES: {
    MODE: 'peering',
    // (peering or login) 
    URL: "https://".concat(NODE_BACKEND_DOMAIN, "/synchro-favorites")
  },
  REAL_TIME: {
    URL: "https://".concat(NODE_WS_BAKEND_DOMAIN)
  },
  SOCIAL: {
    TWITTER: {
      POST_PER_PAGE: 10
    },
    YOUTUBE: {
      POST_PER_PAGE: 5
    },
    URL: "https://".concat(NODE_BACKEND_DOMAIN, "/social")
  }
});